<template>

  <main class="w-full h-full" v-if="item">
    
      <div class="sb-carousel" @click.prevent="changeSlide" @mousemove="slideCursor" @mouseleave="$root.$emit('resetCursor')" v-hammer:swipe.horizontal="swipeSlide">
            <div class="track" :style="`transform: translateX(calc(${slide} * -100%))`" :class="{ timeout: timeout }">
                  <div v-for="(img, index) in slides" :key="index">
                        <img class="w-full h-screen object-cover" :style="`object-position: ${img.focusX}% ${img.focusY}%`" v-lazy="img.thumb" :data-srcset="img.srcset" alt="">
                  </div>
            </div>
      </div>

      <div @click="showinfo = !showinfo" @mouseenter="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')" :class="{ 'rotate-45': showinfo }" class="absolute top-12 lg:top-16 inline-block text-white mix-blend-exclusion left-4 text-2xl lg:text-4xl transition-transform origin-center duration-1000 transform">
            +
      </div>

      <div class="sb-slideout mix-blend-exclusion" :class="{ 'active': showinfo }">
            <div class="pt-1 transition text-white mix-blend-exclusion duration-1000 px-4 text-xl lg:text-4xl">
                  <div v-html="item.furnituretype"></div>
                  <div>{{ item.material }}</div>
                  <div>{{ item.width }} × {{ item.depth }} × {{ item.height }} cm</div>
                  <br>
                  <div v-if="item.price && item.price > 0 && item.ondemand == 'false'">CHF {{ item.price }}</div>
                  <br v-if="item.price && item.price > 0 && item.ondemand == 'false'">
                  <div v-if="item.description" class="max-w-4xl" v-html="item.description"></div>
                  <br v-if="item.description">
                  <a v-if="item.ondemand == 'true'" :href="'mailto:info@squadrab.ch?subject=' + this.item.title" class="w-auto border-white border text-white mix-blend-exclusion p-1 px-2 text-xl lg:text-4xl hover:opacity-40">
                        Prix sur demande
                  </a>
                  <template v-else>
                        <button v-if="item.price && item.price > 0 && item.stock > 0" @click="addToCart" @mouseenter.prevent="$root.$emit('changeCursor', '&#x25C6;')" @mouseleave="$root.$emit('resetCursor')" class="w-auto border-white border text-white mix-blend-exclusion p-1 px-2 text-xl lg:text-4xl hover:opacity-40">
                              Ajouter au panier
                        </button>
                        <div v-else class="inline-block w-auto border-white border text-white mix-blend-exclusion p-1 px-2 text-xl lg:text-4xl opacity-40">
                              En rupture de stock
                        </div>
                  </template>
            </div>
      </div>
</main>
</template>

<script>
export default {
  name: "item",
  metaInfo() {
    return {
      title: "– " + this.item.title,
    };
  },
  data() {
    return {
      showinfo: false,
      slide: 0,
      timeout: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.$root.$emit('pageTitle', this.item.title);
       this.$root.$emit('imgCounter', this.displaySlideIndex);
    }, 1000);
    let carousel = document.querySelector('.sb-carousel');
    carousel.style.height = window.innerHeight + 'px';
    window.addEventListener('resize', () => {
       carousel.style.height = window.innerHeight + 'px';
    });
  },
  computed: {
    item() {
      return this.$store.state.item;
    },
    slides() {
      return this.item.images.concat(this.item.images.concat(this.item.images));
    },
    total() {
      return this.item.images.length;
    },
    imgindex() {
      return this.slide % this.total;
    },
    displaySlideIndex() {
      if(this.total < 2) {
            return '';
      } else {
            return  parseInt(this.imgindex + 1) + '/' + this.total;
      }
    }
  },
   methods: {
    slideCursor(event) {
      if(event.clientX < window.innerWidth / 2) {
        this.$root.$emit('changeCursor', '&#x25C0;');
      } else {
        this.$root.$emit('changeCursor', '&#x25B6;');
      }
    },
    changeSlide(event) {
      if(event.clientX < window.innerWidth / 2) {
        this.prevSlide();
      } else {
        this.nextSlide();
      }
    },
    swipeSlide(event) {
      if(event.direction == 2) {
            this.nextSlide();
      } else {
            this.prevSlide();
      }
    },
    nextSlide() {
      if(!this.timeout) {
        if(this.imgindex + 1 == this.total) {
          this.slide++;
           this.timeout = true;
            setTimeout(() => {
              this.timeout = false;
              this.slide = 0;
            }, 1000);
        } else {
          this.slide++;
           this.timeout = true;
            setTimeout(() => {
              this.timeout = false;
            }, 1000);
        }
       this.$root.$emit('pageTitle', this.item.title);
       this.$root.$emit('imgCounter', this.displaySlideIndex);
      }
    },
    prevSlide() {
      if(!this.timeout) {
        if(this.imgindex == 0) {
          this.slide = this.total - 1;
           this.timeout = true;
            setTimeout(() => {
              this.timeout = false;
              this.slide = this.total - 1;
            }, 1000);
        } else {
          this.slide--;
           this.timeout = true;
            setTimeout(() => {
              this.timeout = false;
            }, 1000);
        }
        this.$root.$emit('pageTitle', this.item.title);
        this.$root.$emit('imgCounter', this.displaySlideIndex);
      }
    },
    addToCart() {
      if(this.item.price > 0) {
            this.$store.commit("addToCart", {
                  title: this.item.title,
                  id: this.item.uid,
                  price: this.item.price,
                  quantity: 1,
                  stock: this.item.stock,
            });
      }
    
    }
   }
};
</script>
